import { Typography } from "@mui/material";
import { ConfirmModal } from "../../components/ConfirmModal";
import { useSession } from "../../hooks/useSession";

type QuoteRequestErrorModalProps = {
  onClose: () => void;
};

export const QuoteRequestErrorModal: React.FC<QuoteRequestErrorModalProps> = ({
  onClose,
}) => {
  const { user } = useSession();
  return (
    <ConfirmModal
      isOpen={true}
      onConfirm={onClose}
      onClose={onClose}
      heading="Unable to confirm this quote"
      confirmButtonText="Okay"
      confirmOnly
      body={
        <Typography variant="body2" color="grey.500">
          {user?.isRetailUser ? "User cannot make this change or this" : "This"} quote has one of the following: unapproved custom options,
          incomplete custom options, incomplete required subgroups, errors.
        </Typography>
      }
    />
  );
};
